import { useEffect, useState } from 'react';

interface UseDynamicSizeProps {
  baseWidth: number;
  ref: React.RefObject<HTMLElement | null>;
}

export const useDynamicSize = ({ baseWidth, ref }: UseDynamicSizeProps) => {
  const [width, setWidth] = useState(baseWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(ref.current?.clientWidth || baseWidth);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [baseWidth, ref]);

  const dynamicSize = (size: number) => `${size * (width / baseWidth)}px`;

  return {
    dynamicSize,
  };
};
